import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {ExternalOffer} from '../../data/models/external-offer.model';
import {ImageService} from './image.service';
import {catchError, map} from 'rxjs/operators';
import {Observable, of, throwError} from 'rxjs';
import {ImageHandler} from "../../image-handler.service";
import {TranslationService} from "./translation.service";

@Injectable({
  providedIn: 'root'
})
export class ExternalOfferService {
  externalOffersForSlider: ExternalOffer[] = [];
  externalOffersForGroup: ExternalOffer[] = [];
  baseUrlSlider: string = '/webabo/externalOffer/slider';
  baseUrlOfferGroup: string = '/webabo/externalOffer/offerGroup/';

  constructor(private httpClient: HttpClient,
              private imageService: ImageService,
              private imageHandler: ImageHandler,
              private translationService: TranslationService
              ) {
  }

  loadExternalOffersForSlider(): any {
    return this.httpClient.get<ExternalOffer[]>(this.baseUrlSlider).pipe(catchError(this.handleError));
  }

  loadExternalOffersForOfferGroup(offerGroupId: string): Observable<ExternalOffer[]> {
    return this.httpClient.get<ExternalOffer[]>(this.baseUrlOfferGroup + offerGroupId).pipe(
      map((offers: ExternalOffer[]) => {
        if (offers) {
          offers.forEach(offer => {
            if (offer.image && offer.image.type) {
              let altText = offer.header ?? this.translationService.getTranslation('externalOffer.image.altText.default');
              offer.image = this.imageHandler.addAltText(offer.image, altText);
            }
          });
        }
        return offers;
      }),
      catchError(this.handleError)
    );
  }

  getExternalOffersForSlider(): ExternalOffer[] {
    this.loadExternalOffersForSlider().subscribe(externalOffers => {
      if (externalOffers) {
        this.externalOffersForSlider = externalOffers;
        this.externalOffersForSlider.forEach(externalOffer => {
          this.imageService.getImageOfExternalOffer(externalOffer.id).subscribe(image => {
            if (image && image.type) {
              externalOffer.image = this.imageHandler.addAltText(image, externalOffer.header ?? this.translationService.getTranslation('externalOffer.image.altText.default'));
            } else {
              externalOffers.splice(externalOffers.indexOf(externalOffer));
            }
          });
        });
      }
    });
    return this.externalOffersForSlider;
  }

  getExternalOffersForOfferGroup(offerGroupId: string): any {
    this.loadExternalOffersForOfferGroup(offerGroupId).subscribe(externalOffers => {
      if (externalOffers) {
        this.externalOffersForGroup = externalOffers;
        this.externalOffersForGroup.forEach(externalOffer => {
          this.imageService.getImageOfExternalOffer(externalOffer.id).subscribe(image => {
            if (image && image.type) {
              externalOffer.image = this.imageHandler.addAltText(image, externalOffer.header ?? this.translationService.getTranslation('externalOffer.image.altText.default'));
            }
          });
        });
      }
    });
    return this.externalOffersForGroup;
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = '';

    if (error.status === 404) {
      errorMessage = 'No ExternalOffers found!';
      console.info(errorMessage);
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
      console.error(errorMessage);
    }

    return throwError(() => errorMessage);
  }
}
